import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Button } from '@jutro/legacy/components';
import messages from './OccupationSearchComponent.messages';
import styles from './OccupationSearchComponent.module.scss';
import metadata from './OccupationSearchComponent.metadata.json5';



function OccupationSearchComponent(props) {

    const { id, updateWizardData, index, viewModelService, submissionVM, pathUpdated, setSubmission } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OccupationSearchComponent');
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const modelVM = _.get(submissionVM, pathUpdated);
    const [occupationCodeSearchVisible, setOccupationCodeSearchVisible] = useState(false);
    const [occupation, updateOccupation] = useState('');
    const occupationPath = `${pathUpdated}.occupation.value`;


    const onCell = (item, index, { id: property }) => {
        return item[property];
    };

    const renderSelectButton = (item, index, { id: property }) => {
        return (
            <Button type='text'  onClick={(e) => onActionClick(item)}>
                Select
            </Button>
        );
    };

    const loadData = ({ pageSize, page }) => {
        const paginationParams = {
            fromPage: page,
            pageSize
        };

        return searchOccupationCode(paginationParams);
    };

    const searchOccupationCode = async(paginationParams) => {
       
        if(!paginationParams) {
            paginationParams = {
                fromPage: 0,
                pageSize: 10
            };
        }

        const reqParam = {
            interestType: occupation,
            pageNumber: paginationParams.fromPage,
            pageSize: paginationParams.pageSize
        }
        
        const response = await LoadSaveService.getRVOccupationClassCodes_Ext(reqParam, authHeader);

        setOccupationCodeSearchVisible(true);

        if (response != null) {
            const resultCodes = response.resultClassCodes
            const objectArrayCodes = resultCodes.map((str) => ({ occupation: str }));

            return {
                rows: objectArrayCodes,
                numberOfRows: response.maxNumberOfResults
            };

        }
 
        return {
            rows: [],
            numberOfRows: 0
        };

        // if(response != null){
            
        //     const resultCodes = response.resultClassCodes
        //     const objectArrayCodes = resultCodes.map((str) => ({ occupation: str }));

        //     return {
        //         rows: objectArrayCodes,
        //         numberOfRows: response.maxNumberOfResults
        //     };

        // } else {
        //     return {
        //         rows: [],
        //         numberOfRows: 0
        //     };
        // }
        
    };

    const clearSearchTexts = () => {
        updateOccupation('');
    }

    const cancelSearch = () => {
        setOccupationCodeSearchVisible(false);
    }

    const openSearchPanel = () => {
        setOccupationCodeSearchVisible(true);
    } 

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onActionClick = (object, index) => {
        _.set(submissionVM, occupationPath, object.occupation);
        setOccupationCodeSearchVisible(false);
        setSubmission(submissionVM);
        // setSubmission(submissionVM, occupationPath, object.occupation)
    };

    // const clearViolationCategory = () => {
    //     _.set(submissionVM, vioCatFiePath, '');
    //     updateWizardData(submissionVM);
    // }

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        occupationSearchIconBtn: {
            onClick: () => { openSearchPanel(); }
        },
        occupationAllContainer: {
            visible: occupationCodeSearchVisible
        },
        occupationSearchContainer: {
            visible: occupationCodeSearchVisible
        },
        occupationSearchInput: {
            value: occupation,
            onValueChange: updateOccupation,
        },
        occupationCodeSearchBtn: {
            onClick: () => { searchOccupationCode(); },
            visible: false
        },
        occupationCodeResetBtn: {
            onClick: () => { clearSearchTexts(); },
        },
        occupationCodeCancelBtn: {
            onClick: () => { cancelSearch(); },
        },
        searchResultHeader: {
            visible: occupationCodeSearchVisible
        },
        occupationAdapters: {
            visible: occupationCodeSearchVisible,
            key: occupation,
            onFetchData: loadData
        }        
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onActionClick,
            onCell,
            renderSelectButton
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback((id, path) =>
         readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OccupationSearchComponent.propTypes = wizardProps;
export default withRouter(OccupationSearchComponent);
